import { render } from "./StoragePositionSelector.vue?vue&type=template&id=9cde28c2"
import script from "./StoragePositionSelector.vue?vue&type=script&lang=js"
export * from "./StoragePositionSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__